<template lang="pug">
Fragment
  .span-full
    div.head.d-lg-flex
      .d-flex
        b-icon.no-print.mr-2(icon="cash-stack" variant="dark" font-scale="1.5")
        h4.mb-0.title Cotización
    hr.ot-divider
  div.details.span-full-screen
    label.input-label Comentario Vendedor
    span.display-data 
      | {{ ov.comentario_vendedor || '-' }}
  div.details.span-full-screen
    label.input-label Comentario de Cierre
    span.display-data {{ ov.comentario_cierre || '-' }}
  div.details
    label.input-label Abono requerido
    span.display-data
      | {{ ov.abono_requerido | formatCurrency }}
  div.details
    label.input-label Monto Abonado
    span.display-data
      | {{ ov.monto_abonado | formatCurrency }}
  div.details
    label.input-label Subtotal Neto
    span.display-data
      | {{ ov.monto_total_neto | formatCurrency }}
  div.details(v-if="ov.monto_descuento > 0")
    label.input-label Descuento
    span.display-data
      | -{{ ov.monto_descuento | formatCurrency }}
  div.details
    label.input-label IVA (19%)
    span.display-data
      | {{ ov.valor_iva | formatCurrency }}
  div.details
    label.input-label Monto Total
    span.display-data
      | {{ ov.monto_total_final | formatCurrency }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuotationData',
  computed: {
    ...mapGetters('OTStore', ['ot', 'printNoDisplay']),
    ov() {
      return this.ot && this.ot.datos_ov_asociada
        ? this.ot.datos_ov_asociada
        : {}
    },
  },
}
</script>
